import {z} from 'zod';

import {optionalHexColour, optionalText} from './catalogueUi';
import {optionalMoneyInput, optionalPriceInput} from './moneyInput';
import {offeredTrimRows} from './utils/offeredTrimRows';

export const colourSchema = z.object({
  name: z.string().min(1),
  kind: optionalText,
  factoryCode: optionalText,
  hex: optionalHexColour,
  /** Create only: fills the price and cost of the trims ticked in `trims`. */
  priceNet: optionalPriceInput,
  costNet: optionalMoneyInput,
  trims: offeredTrimRows,
});
